import RestService from '../services/rest';

// GET
async function listCrossdockingCustomerOrders(branchCode, productCode, inboundOrderId) {
  return RestService.getAuthenticated('crossdocking/list/customerOrders', {
    branchCode,
    productCode,
    inboundOrderId,
  });
}

async function getAllCrossdockings() {
  return RestService.getAuthenticated('crossdocking/list/all');
}

// POST
async function cancelCrossdocking(crossdockingIds) {
  return RestService.postAuthenticated('crossdocking/cancelCrossdocking', { crossdockingIds });
}

export default {
  listCrossdockingCustomerOrders,
  getAllCrossdockings,
  cancelCrossdocking,
};
